import type { PromptStarterListContextValue, PromptStarterListState } from './PromptStarterList.types';

export function usePromptStarterListContextValues(state: PromptStarterListState): PromptStarterListContextValue {
  const { numberOfColumns } = state;

  return {
    numberOfColumns,
  };
}
